//TODO: fix any in this file when fixing the normal history views
export const isRefundPossible = (order: any) => {
  const orderHasBeenCompleted = order?.status === 'COMPLETED';
  const orderHasBeenRefunded = order?.status === 'REFUNDED';
  const thereAreItemsToRefund = order?.items.some((item: any) => !item.isRefunded);
  const thereIsATipToRefund = order?.payment.correctedTip && order?.payment.correctedTip > 0;

  return (
    (orderHasBeenCompleted && thereAreItemsToRefund) ||
    ((orderHasBeenCompleted || orderHasBeenRefunded) && thereIsATipToRefund)
  );
};

/** An order's items as the refund provider wants them */
export const toRefundItems = (items: any[], i18n: (lang: any) => string) =>
  items.map((i) => ({
    amount: i.price.amount,
    entryId: i.entry.id,
    fraction: i.fraction,
    title: i18n(i.entry.item.titleLang),
    categoryId: i.entry.item.categories[0].id,
    categoryName: i.entry.item.categories[0].name,
    discount: i.price.discount,
    id: i.id,
    itemId: i.entry.item.id,
    vatRate: i.price.percentageVAT,
  }));
